/**
    @param {number} r red color (0-255)
    @param {number} g green color (0-255)
    @param {number} b blue color (0-255)
    @returns {string} color in hex
    @description convert rgb to rgb in hex format
*/
const RGBToHex = (r, g, b) => {
  const f = (n) => {
    let nn = n.toString(16);
    if (nn.length != 2) return "0" + nn;
    return nn;
  };
  return `#${f(r)}${f(g)}${f(b)}`;
};
export default RGBToHex;
